module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.classes
  }, [_vm._t("default"), _vm._v(" "), _c('input', {
    attrs: {
      "type": "radio",
      "name": _vm.radioName,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.status,
      "value": _vm.value
    },
    on: {
      "change": _vm._change
    }
  }), _vm._v(" "), _c('span')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f58c464e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/radio/radio.vue
// module id = 722
// module chunks = 85